import type { TRuleWithTheme } from '@ackee/fela';

export const extendContainer: TRuleWithTheme<{ fade?: boolean; isDevelopmentPage?: boolean }> = ({
    fade,
    isDevelopmentPage,
}) => ({
    display: 'flex',
    gridTemplateColumns: 'repeat(auto-fill, minmax(20px, 1fr))',
    gridColumnGap: '0.3rem',
    gridRowGap: '4rem',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    willChange: 'opacity',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) opacity 0.3s',
    opacity: fade ? 0 : 1,

    tabletLarge: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(6.68365%, 1fr))',
        gridColumnGap: '5.25rem',
        gridRowGap: '4rem',
        width: isDevelopmentPage ? '100%' : '80%',
        overflow: 'visible',
    },
});

export const extendText: TRuleWithTheme = ({ theme: { colors } }) => ({
    flexBasis: '100%',
    gridColumn: 'auto / span 12',
    color: colors.lightGrey,
    marginBottom: '4rem',

    tabletLarge: {
        marginBottom: '5.1875rem',
    },
});

export const extendItemContainer: TRuleWithTheme = () => ({
    width: '105px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'visible',
    fontSize: '1.125rem',
    textAlign: 'center',
    marginBottom: 0,

    tabletLarge: {
        minWidth: '5rem',
        width: 'auto',
    },
});

export const imageContainer: TRuleWithTheme = () => ({
    height: '5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '0.5rem',
});

export const image = () => ({
    transform: 'scale(0.8)',

    tabletLarge: {
        transform: 'scale(1)',
    },
});

export const link: TRuleWithTheme = ({ theme: { colors } }) => ({
    color: colors.black,
    width: '6.675rem',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
    willChange: 'color',
    whiteSpace: 'nowrap',

    ':hover': {
        color: colors.blue,
    },
});
